import styled from 'styled-components';

import { H4 } from '~/src/common/components/Typography';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(H4)`
  margin: 0;
`;
